import type { IconName } from '#ui/MaterialIcon.js';

import { useState } from 'react';

import { cn } from '@elara/client-core/lib/utils';

import { AppImage } from '#ui/AppImage.js';
import { IconSizes, MaterialIcon } from '#ui/MaterialIcon.js';

/**
 * Renders an external image (a favicon or brand logo) in the row's logo slot, with
 * automatic fallback to a Material icon (default: `globe`) if the image fails to
 * load. Works best with origin-based `/favicon.ico` URLs where a missing file
 * returns a real 404 (so `onError` fires); aggregator services like Google's s2
 * or DuckDuckGo return synthetic placeholders instead, defeating the fallback.
 */
export function FaviconImage({
  src,
  className,
  fallbackIcon = 'globe',
}: {
  src: string;
  className?: string;
  fallbackIcon?: IconName;
}) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <MaterialIcon icon={fallbackIcon} size={IconSizes.xs} className="shrink-0 text-muted-foreground" />;
  }
  return (
    <AppImage
      src={src}
      alt=""
      onError={() => setFailed(true)}
      className={cn('shrink-0 w-4 h-4 rounded-xs object-contain bg-white', className)}
    />
  );
}
